// extracted by mini-css-extract-plugin
export default {"spoiler":"J7xLE","spoilerOpened":"BJxlI","icon":"UyBU4","header":"D9TSe","title":"My0lA","inner":"TXzau","text":"MrPj2"};